<template>
  <div>
    <Row>
      <Col
        :xs="{span:24,offset:0}"
        :sm="{span:12,offset:0}"
        :md="{span:10,offset:2}"
        :lg="{span:10,offset:2}">
        <div :class="$style.left">
          <div :class="$style.screenShoot">
            <Carousel
              v-model="value3"
              :autoplay="setting.autoplay"
              :autoplay-speed="setting.autoplaySpeed"
              :loop="setting.loop"
              :dots="setting.dots"
              :radius-dot="setting.radiusDot"
              :trigger="setting.trigger"
              :arrow="setting.arrow">
              <CarouselItem
                v-for="(img, index) in screenShoots"
                :key="index">
                <div class="demo-carousel">
                  <img :src="img" :class="$style.screenShoot"/>
                </div>
              </CarouselItem>
            </Carousel>
          </div>
        </div>
      </Col>
      <Col
        :xs="{span:24,offset:0}"
        :sm="{span:12,offset:0}"
        :md="{span:10,offset:0}"
        :lg="{span:10,offset:0}">
        <div :class="$style.right">
          <div :class="$style.textArea">
            Topeke
          </div>
          <div :class="$style.buttonArea">
            <div v-for="(os, index) in downloadLinks"
              :key="index"
              :class="[$style.downloadLink, os.enable?'':$style.downloadLink_disable]" >
              <Icon :type="os.icon" size="32"></Icon>
              <a v-if="os.enable" target="_blank" :href="os.url">
                {{os.title}}
              </a>
              <span v-else>{{os.title}}</span>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: 'MainPage',
  data () {
    return {
      screenShoots: [
        require('../assets/ss01.jpg'),
        require('../assets/ss02.jpg'),
        require('../assets/ss03.jpg')
      ],
      downloadLinks: [
        {
          'title': 'iOS',
          'icon': 'social-apple',
          'url': 'https://itunes.apple.com/jp/app/topeko/id828938883?mt=8',
          'enable': true
        },
        {
          'title': 'Android(coming soon)',
          'icon': 'social-android',
          'url': '',
          'enable': false
        }
      ],
      value3: 0,
      setting: {
        autoplay: true,
        autoplaySpeed: 2000,
        loop: false,
        dots: 'outside',
        radiusDot: true,
        trigger: 'click',
        arrow: 'never'
      }
    }
  },
  created: function () {
    console.debug('UserId')
  },
  methods: {
  }
}
</script>

<style module>
.demo-carousel {
  display: block;
  width: 320px;
  background-color: transparent;
  height: 542px;
}
div.left {
  width: 100%;
}
div.screenShoot {
  display: block;
  width: 320px;
  text-align: center;
}
img.screenShoot {
  width: 250px;
  height: 542px;
  border-radius: 20px;
}
div.right {
  height: 560px;
  display : flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding-bottom: 100px;
}
div.textArea {
  font-size: x-large;
  font-weight: bold;
  text-align: left;
  bottom: 100px;
}
div.buttonArea {
  display: block;
  background: transparent;
  bottom: 0px;
  float: bottom;
}
div.downloadLink {
  vertical-align: middle;
  margin: 10px;
  color: #58b2dc;
}
div.downloadLink_disable {
  color: #aaa;
}
div.downloadLink a {
  display: inline-block;
  vertical-align: top;
  line-height: 32px;
  height: 32px;
  width: 200px;
  color: #fff;
  background-color: #58b2dc;
  font-size: medium;
  font-weight: bold;
  border-radius: 16px;
  margin-left: 10px;
}
div.downloadLink span {
  display: inline-block;
  vertical-align: top;
  line-height: 32px;
  height: 32px;
  width: 200px;
  color: #fff;
  background-color: #aaa;
  font-size: medium;
  font-weight: bold;
  border-radius: 16px;
  margin-left: 10px;
}
@media (max-width: 768px)  {
  div.left {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  div.right {
    height: 100%;
    display : flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue